import * as React from "react";

function BusinessIllustration() {
  return (
    <div>
      <svg viewBox="0 0 600 600" className="w-full h-auto rounded-[16px]">
        <defs>
          <linearGradient id="skyGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{stopColor:"#87CEEB", stopOpacity:1}} />
            <stop offset="100%" style={{stopColor:"#E0F6FF", stopOpacity:1}} />
          </linearGradient>
          <filter id="shadow1" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
            <feOffset dx="0" dy="2" result="offsetblur" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.3" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter id="shadow2" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="4" />
            <feOffset dx="0" dy="3" result="offsetblur" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.2" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Sky background */}
        <rect width="600" height="600" fill="url(#skyGradient)" />

        {/* Trees/foliage - left side */}
        <ellipse cx="120" cy="80" rx="45" ry="45" fill="#7CB342" opacity="0.8" />
        <ellipse cx="100" cy="95" rx="35" ry="35" fill="#8BC34A" opacity="0.9" />
        <ellipse cx="145" cy="100" rx="30" ry="30" fill="#9CCC65" opacity="0.85" />
        <ellipse cx="125" cy="115" rx="25" ry="25" fill="#AED581" opacity="0.8" />

        {/* Trees/foliage - right side */}
        <ellipse cx="480" cy="90" rx="50" ry="50" fill="#7CB342" opacity="0.8" />
        <ellipse cx="460" cy="105" rx="40" ry="40" fill="#8BC34A" opacity="0.9" />
        <ellipse cx="505" cy="110" rx="35" ry="35" fill="#9CCC65" opacity="0.85" />
        <ellipse cx="485" cy="125" rx="30" ry="30" fill="#AED581" opacity="0.8" />

        {/* Building structure */}
        <rect x="420" y="60" width="80" height="15" fill="#D84315" opacity="0.9" />
        <rect x="425" y="75" width="70" height="50" fill="#E64A19" opacity="0.85" />
        <rect x="430" y="80" width="60" height="40" fill="#FF5722" opacity="0.8" />
        <rect x="440" y="85" width="15" height="20" fill="#FFCCBC" opacity="0.7" />
        <rect x="465" y="85" width="15" height="20" fill="#FFCCBC" opacity="0.7" />

        {/* Form/document interface - left */}
        <rect x="70" y="200" width="120" height="140" fill="#FFFFFF" filter="url(#shadow1)" rx="8" />
        <rect x="80" y="210" width="100" height="80" fill="#F5F5F5" rx="4" />
        <rect x="85" y="215" width="90" height="5" fill="#E0E0E0" rx="2" />
        <rect x="85" y="225" width="90" height="5" fill="#E0E0E0" rx="2" />
        <rect x="85" y="235" width="60" height="5" fill="#E0E0E0" rx="2" />
        <rect x="90" y="250" width="30" height="30" fill="#FFA726" rx="4" />
        <rect x="130" y="250" width="30" height="30" fill="#42A5F5" rx="4" />
        <rect x="80" y="300" width="100" height="30" fill="#66BB6A" rx="4" />
        <text x="130" y="320" fontFamily="Inter, sans-serif" fontSize="12" fill="#FFFFFF" textAnchor="middle" fontWeight="600">Submit</text>

        {/* Verification checkmark - right */}
        <rect x="410" y="200" width="120" height="140" fill="#FFFFFF" filter="url(#shadow1)" rx="8" />
        <circle cx="470" cy="250" r="35" fill="#4CAF50" />
        <path d="M 455 250 L 465 260 L 485 240" stroke="#FFFFFF" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <text x="470" y="310" fontFamily="Inter, sans-serif" fontSize="11" fill="#333333" textAnchor="middle" fontWeight="500">Verified</text>

        {/* User avatars */}
        <circle cx="150" cy="160" r="30" fill="#FFFFFF" filter="url(#shadow1)" />
        <circle cx="150" cy="155" r="12" fill="#FFB74D" />
        <path d="M 150 167 Q 135 185 135 195 L 165 195 Q 165 185 150 167 Z" fill="#FFB74D" />

        <circle cx="380" cy="170" r="32" fill="#FFFFFF" filter="url(#shadow1)" />
        <circle cx="380" cy="165" r="13" fill="#64B5F6" />
        <path d="M 380 178 Q 363 198 363 208 L 397 208 Q 397 198 380 178 Z" fill="#64B5F6" />

        {/* Analytics dashboard */}
        <rect x="200" y="280" width="200" height="140" fill="#FFFFFF" filter="url(#shadow2)" rx="8" />
        <rect x="210" y="290" width="180" height="100" fill="#F8F9FA" rx="4" />
        <rect x="220" y="300" width="40" height="70" fill="#FF9800" rx="2" />
        <rect x="270" y="320" width="40" height="50" fill="#2196F3" rx="2" />
        <rect x="320" y="310" width="40" height="60" fill="#4CAF50" rx="2" />

        {/* Chart elements */}
        <circle cx="380" cy="310" r="25" fill="#E3F2FD" />
        <path d="M 365 310 L 375 310 L 375 320 Q 375 325 370 325 Q 365 325 365 320 Z" fill="#42A5F5" />
        <path d="M 375 310 L 385 310 L 385 320 Q 385 325 380 325 Q 375 325 375 320 Z" fill="#1E88E5" />

        <circle cx="340" cy="325" r="18" fill="#C8E6C9" />
        <path d="M 330 330 L 335 335 L 350 320" stroke="#4CAF50" strokeWidth="3" fill="none" strokeLinecap="round" />

        {/* Chart bars highlights */}
        <rect x="215" y="300" width="5" height="70" fill="#F57C00" />
        <rect x="265" y="320" width="5" height="50" fill="#1976D2" />
        <rect x="315" y="310" width="5" height="60" fill="#388E3C" />

        {/* Product/pricing card */}
        <rect x="150" y="450" width="80" height="100" fill="#FFA726" filter="url(#shadow1)" rx="6" />
        <rect x="155" y="455" width="70" height="50" fill="#424242" rx="3" />
        <rect x="160" y="460" width="60" height="40" fill="#37474F" />
        <rect x="165" y="465" width="15" height="8" fill="#4CAF50" rx="1" />
        <rect x="185" y="465" width="15" height="8" fill="#4CAF50" rx="1" />
        <rect x="205" y="465" width="15" height="8" fill="#4CAF50" rx="1" />
        <rect x="165" y="478" width="15" height="8" fill="#FF5722" rx="1" />
        <rect x="185" y="478" width="15" height="8" fill="#2196F3" rx="1" />
        <rect x="205" y="478" width="15" height="8" fill="#FFC107" rx="1" />
        <rect x="165" y="491" width="50" height="8" fill="#9E9E9E" rx="1" />
        <rect x="160" y="510" width="60" height="30" fill="#FFB74D" rx="3" />
        <text x="190" y="530" fontFamily="Inter, sans-serif" fontSize="10" fill="#333333" textAnchor="middle" fontWeight="600">£55.99</text>

        {/* Currency symbols */}
        <circle cx="100" cy="500" r="20" fill="#FFB300" filter="url(#shadow1)" />
        <circle cx="100" cy="500" r="15" fill="#FFC107" />
        <text x="100" y="505" fontFamily="Inter, sans-serif" fontSize="14" fill="#FFFFFF" textAnchor="middle" fontWeight="700">$</text>

        <circle cx="120" cy="520" r="18" fill="#FFB300" filter="url(#shadow1)" />
        <circle cx="120" cy="520" r="13" fill="#FFC107" />
        <text x="120" y="525" fontFamily="Inter, sans-serif" fontSize="12" fill="#FFFFFF" textAnchor="middle" fontWeight="700">$</text>

        <circle cx="95" cy="530" r="16" fill="#FFB300" filter="url(#shadow1)" />
        <circle cx="95" cy="530" r="11" fill="#FFC107" />
        <text x="95" y="535" fontFamily="Inter, sans-serif" fontSize="10" fill="#FFFFFF" textAnchor="middle" fontWeight="700">$</text>

        {/* Success indicators */}
        <circle cx="330" cy="480" r="35" fill="#FFFFFF" filter="url(#shadow2)" />
        <circle cx="330" cy="480" r="28" fill="#E3F2FD" />
        <path d="M 320 485 L 325 490 L 340 475" stroke="#2196F3" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="330" cy="480" r="20" fill="none" stroke="#42A5F5" strokeWidth="2" />

        {/* Task management interface */}
        <rect x="380" y="460" width="90" height="110" fill="#FFFFFF" filter="url(#shadow1)" rx="6" />
        <rect x="390" y="470" width="70" height="50" fill="#F5F5F5" rx="3" />
        <circle cx="425" cy="490" r="8" fill="#4CAF50" />
        <circle cx="425" cy="505" r="6" fill="#2196F3" />
        <rect x="395" y="530" width="60" height="30" fill="#E8F5E9" rx="3" />
        <path d="M 405 540 L 410 545 L 420 535" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" />
        <path d="M 405 550 L 410 555 L 420 545" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" />

        {/* Financial indicators */}
        <circle cx="480" cy="520" r="30" fill="#FFFFFF" filter="url(#shadow1)" />
        <circle cx="480" cy="520" r="24" fill="#4CAF50" />
        <text x="480" y="528" fontFamily="Inter, sans-serif" fontSize="18" fill="#FFFFFF" textAnchor="middle" fontWeight="700">$</text>

        <circle cx="510" cy="490" r="25" fill="#FFFFFF" filter="url(#shadow1)" />
        <circle cx="510" cy="490" r="20" fill="#2196F3" />
        <path d="M 505 485 L 505 495 M 500 490 L 510 490" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />

        <circle cx="520" cy="530" r="22" fill="#FFFFFF" filter="url(#shadow1)" />
        <circle cx="520" cy="530" r="17" fill="#FF9800" />
        <circle cx="520" cy="530" r="10" fill="#FFFFFF" />
        <circle cx="520" cy="530" r="5" fill="#FF9800" />

        {/* Communication/messaging */}
        <ellipse cx="280" cy="180" r="28" ry="28" fill="#FFFFFF" filter="url(#shadow1)" />
        <ellipse cx="280" cy="180" r="22" ry="22" fill="#E3F2FD" />
        <path d="M 270 180 Q 280 170 290 180 Q 280 190 270 180 Z" fill="#42A5F5" />
        <circle cx="275" cy="177" r="2" fill="#FFFFFF" />
        <circle cx="285" cy="177" r="2" fill="#FFFFFF" />

        {/* User profile */}
        <rect x="260" y="450" width="60" height="80" fill="#FFFFFF" filter="url(#shadow1)" rx="30" />
        <rect x="265" y="455" width="50" height="70" fill="#F5F5F5" rx="25" />
        <circle cx="290" cy="475" r="12" fill="#FFB74D" />
        <path d="M 290 487 Q 275 502 275 512 L 305 512 Q 305 502 290 487 Z" fill="#FFB74D" />
        <circle cx="283" cy="472" r="2" fill="#333333" />
        <circle cx="297" cy="472" r="2" fill="#333333" />
        <path d="M 285 480 Q 290 483 295 480" stroke="#333333" strokeWidth="1.5" fill="none" strokeLinecap="round" />

        {/* Additional UI elements */}
        <circle cx="60" cy="380" r="25" fill="#FFFFFF" filter="url(#shadow1)" />
        <path d="M 50 380 L 55 385 L 70 370" stroke="#4CAF50" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="60" cy="380" r="18" fill="none" stroke="#66BB6A" strokeWidth="2" />

        <circle cx="540" cy="380" r="28" fill="#FFFFFF" filter="url(#shadow1)" />
        <circle cx="540" cy="380" r="22" fill="#E8EAF6" />
        <path d="M 530 375 L 535 370 L 540 375 L 545 370 L 550 375" stroke="#5C6BC0" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M 530 385 L 535 380 L 540 385 L 545 380 L 550 385" stroke="#5C6BC0" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />

        {/* Notification/alert */}
        <circle cx="540" cy="250" r="26" fill="#FFFFFF" filter="url(#shadow1)" />
        <circle cx="540" cy="250" r="20" fill="#FFF3E0" />
        <path d="M 540 240 Q 545 245 540 250 Q 535 245 540 240 Z" fill="#FF9800" />
        <ellipse cx="540" cy="255" rx="8" ry="12" fill="#FF9800" />
        <ellipse cx="535" cy="258" rx="3" ry="5" fill="#FFB74D" />
        <ellipse cx="545" cy="258" rx="3" ry="5" fill="#FFB74D" />

        {/* Settings/configuration */}
        <rect x="500" y="340" width="50" height="50" fill="#FFFFFF" filter="url(#shadow1)" rx="25" />
        <circle cx="525" cy="360" r="8" fill="#42A5F5" />
        <circle cx="525" cy="375" r="5" fill="#1E88E5" />
        <path d="M 515 365 Q 525 355 535 365" stroke="#42A5F5" strokeWidth="2" fill="none" strokeLinecap="round" />

        {/* Small user avatar */}
        <rect x="40" y="320" width="45" height="45" fill="#FFFFFF" filter="url(#shadow1)" rx="22" />
        <circle cx="62.5" cy="337" r="6" fill="#FFB74D" />
        <path d="M 62.5 343 Q 52 355 52 362 L 73 362 Q 73 355 62.5 343 Z" fill="#FFB74D" />
        <circle cx="58" cy="335" r="1.5" fill="#333333" />
        <circle cx="67" cy="335" r="1.5" fill="#333333" />
        <path d="M 59 340 Q 62.5 342 66 340" stroke="#333333" strokeWidth="1" fill="none" strokeLinecap="round" />

        {/* Success checkmark */}
        <circle cx="250" cy="540" r="20" fill="#FFFFFF" filter="url(#shadow1)" />
        <circle cx="250" cy="540" r="15" fill="#E8F5E9" />
        <path d="M 245 535 L 248 538 L 255 531" stroke="#4CAF50" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />

        {/* Target/goal indicator */}
        <circle cx="450" cy="380" r="24" fill="#FFFFFF" filter="url(#shadow1)" />
        <circle cx="450" cy="380" r="18" fill="#FFF3E0" />
        <circle cx="450" cy="380" r="12" fill="#FF9800" />
        <path d="M 445 375 L 450 370 L 455 375 L 450 380 Z" fill="#FFFFFF" />
        <path d="M 445 385 L 450 390 L 455 385 L 450 380 Z" fill="#FFFFFF" />
      </svg>
    </div>
  );
}

export default BusinessIllustration;
